




































































































import Vue from 'vue'
import { UploadFile } from 'src/types/common'

export default Vue.extend({
  name: 'SampleComponents',
  data() {
    return {
      valueInput: '入力フォーム',
      valueTextarea: 'テキストエリア',
      checkConsent: {
        label: 'チェックラベル',
        value: false,
      },
      fileType: ['txt', 'pdf', 'docx', 'xlsx', 'png', 'jpg'],
      downloadFile: {
        attachedFileDataBase64:
          'data:image/png;base64,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',
        attachedFileName: 'pngファイル',
      },
      richText: 'デフォルトメッセージ',
      testDate: '2022-01-01 12:00:00',
      selectedSingle: 0,
      placeholder: 'プレースホルダー名',
      selectedMulti: [],
      selectItems: [
        {
          text: 'オプション名1',
          value: 1,
        },
        {
          text: 'オプション名2',
          value: 2,
        },
        {
          text: 'オプション名3',
          value: 3,
        },
      ],
      isRadio: 0,
      tableList: [
        {
          itemId: 1,
          itemName: 'テスト1',
        },
        {
          itemId: 2,
          itemName: 'テスト2',
        },
        {
          itemId: 3,
          itemName: 'テスト3',
        },
        {
          itemId: 4,
          itemName: 'テスト4',
        },
        {
          itemId: 5,
          itemName: 'テスト5',
        },
      ],
      cardButton: {
        serviceName: 'ホテル',
        iconName: 'service-hotel',
        count: 0,
      },
      pagination: {
        currentPage: 1,
        total: 150,
      },
    }
  },
  methods: {
    fileUpload: (file: UploadFile) => {
      console.log(file)
    },
    beforeDownload: () => {
      console.log('beforeDownload')
    },
    handleCardButton() {
      console.log('handleCardButton')
    },
  },
})
